'use es6';

import Template from './Template';
/**
 * Wrapper class of Template data coming from /templates/:id/buffer
 * Intended for reflection and helper methods.
 */

export default class TemplateBuffer extends Template {
  /**
   * @constructor
   */
  constructor(props) {
    return super(props);
  }

}